module.exports = __webpack_public_path__ + "img/TR-In-1.3ff3f704.gif";